import React from 'react';
import { useIntl } from 'react-intl';

import shipFrom from './shipFrom.svg';
import { OnboardCard } from '../../onboard-card';
import { useHomePageOnboardContext } from '../../../../home-page-onboard-context';
import { ShipFromCardBody } from './ship-from-card-body';
import { ShipFromCardFooter } from './ship-from-card-footer';

import { messages } from '../../messages';

export const ShipFromCard = () => {
  const intl = useIntl();
  const { isShipFromComplete } = useHomePageOnboardContext();
  const title = isShipFromComplete ? messages.shipFromCardTitleComplete : messages.shipFromCardTitleIncomplete;
  const headerImage = <img alt={intl.formatMessage(messages.shipFromAltText)} src={shipFrom} />;
  return (
    <>
      <OnboardCard headerImage={headerImage} isComplete={isShipFromComplete} title={title}>
        <ShipFromCardBody />
        <ShipFromCardFooter />
      </OnboardCard>
    </>
  );
};
